import { useCartStore } from 'stores/useCartStore';
import { useCustomerStore } from 'stores/useCustomerStore';

export const getMaxAllowedQuantity = (variantId: string, max: number = 1) => {
  const customer = useCustomerStore.getState().customer;
  const orders = customer?.orders?.nodes;

  let variants: {
    id: string;
    quantity: number;
    max: number;
  }[] = [];

  orders?.forEach((order) => {
    const date = new Date(order.processedAt);
    const now = new Date();
    const sevenDaysAgo = new Date(now.setDate(now.getDate() - 7));
    if (date > sevenDaysAgo) {
      order.lineItems.nodes.forEach((node) => {
        if (node.variant) {
          const variant = variants.find(
            (variant) => variant.id === node.variant?.id
          );
          if (variant) {
            variant.quantity += node.quantity;
          } else {
            variants.push({
              id: node.variant?.id as string,
              quantity: node.quantity,
              // @ts-expect-error max is a metafield
              max: Number(node?.variant?.product?.max?.value) ?? 1
            });
          }
        }
      });
    }
  });

  const variant = variants.find((variant) => variant.id === variantId);
  if (variant) {
    return variant.max - variant.quantity;
  } else {
    return max;
  }
};
